import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import { MoreCaseStudies } from '../../../../components';

import { meta } from '../../index.js';

export default class tlo extends Component {
	render () {
		return (
			<React.Fragment>
				<Helmet
					title={meta.title.replace('blueshyft', 'The Lottery Office')}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
				<section className="case-study"> 

				    <div className="container">

				        <div className="title">

				            <a href="https://www.lotteryoffice.com.au" target="_blank"> <img src="/images/new/logos/the-lottery-office.svg"/></a>
				            <h3>New way to win big</h3>
				            <p>Proudly Australian owned, The Lottery Office is a lottery operator that provides customers the chance to win some of the biggest jackpots in the world! Established in 2018, The Lottery Office has been operating under the parent company Global Players Network since 2003. The Lottery Office sought out ways to provide greater flexibility to their customers and reached out to blueshyft to expand their channel reach.</p>

				        </div>

						<div className="block">
						
							<h4>A first access to overseas lotteries</h4>
							<p>Customer accessibility is a primary focus for The Lottery Office. The Lottery Office saw value in establishing a brick and mortar presence across the country to open up an additional channel of engagement with players.</p>
							<p>The integration with blueshyft has allowed customers the ability to be referred for an account with The Lottery Office in-store. Players can also deposit funds into their Lottery Office account which can then be used to enter draws. The benefits include:</p>
						
							<div className="features">

								<div className="feature">
									<img src="/images/new/icons/document-blue.svg"/>
									<p>In-store customer acquisition</p>
								</div>
								<div className="feature">
									<img src="/images/new/icons/wallet-blue.svg"/>
									<p>Instant in-store Payments</p>
								</div>
								<div className="feature">
									<img src="/images/new/icons/map-blue.svg"/>
									<p>1,400+ convenient locations</p>
								</div>

							</div>

						</div>

				        <div className="block">

				            <h4>More options for Aussies</h4>
				            <p>The new partnership will provide further convenience and engagement for Lottery players and will allow the following:</p>
				            <p>•  Customer Deposits - using the blueshyft platform, any customer can deposit funds into their Lottery Office account instantly</p>
				            <p>•  Customer Referrals - blueshyft has allowed The Lottery Office customers to open an account in-store via the iPad</p>
				            <p>•  In-store Marketing - blueshyft facilitated in-store marketing, allowing animated content to be deployed on the blueshyft POS app</p>

				        </div>

				        <div className="highlight">
							<p className="highlight-quote">“Collaborating with the team at blueshyft has really enabled us to leverage a whole new channel. With Blueshyft and The Lottery Office both being proudly Australian-owned companies, it's great to have a like-minded partner who values supporting the local economy and community as much as we do.”</p>
							<p className="highlight-quote-role">Jaclyn Wood, CEO @ The Lottery Office</p>
				        </div>

				    </div>

				</section>

				<MoreCaseStudies cases={['lb', 'goget', 'news']} />

			</React.Fragment>
		);
	}
};


// WEBPACK FOOTER //
// ./client/scenes/Clients/scenes/tlo/index.js